import { useEffect } from 'react';
import { OverlayProvider } from 'react-aria';
import { ProductEpdDataModal, ProductEpdDataModalTranslations } from '@shared/components/ProductEpdDataModal/ProductEpdDataModal';
import { useProductEpdDataStore } from './store/productEpdDataStore';
import { RequestMissingEpdModalTranslations } from '@/shared/components/RequestMissingEpdModal/RequestMissingEpdModal';

export function App() {
  const isModalOpen = useProductEpdDataStore((state) => state.isModalOpen);
  const epdDataOptions = useProductEpdDataStore((state) => state.epdDataOptions);
  const epdRawData = useProductEpdDataStore((state) => state.epdRawData);
  const selectedEpdDataIds = useProductEpdDataStore((state) => state.selectedEpdDataIds);
  const error = useProductEpdDataStore((state) => state.error);
  const sourceType = useProductEpdDataStore((state) => state.sourceType);
  const translations = useProductEpdDataStore((state) => state.translations);
  const requestMissingEpdTranslations = useProductEpdDataStore((state) => state.requestMissingEpdTranslations);

  const setModalOpen = useProductEpdDataStore((state) => state.setModalOpen);
  const updateSelectedData = useProductEpdDataStore((state) => state.updateSelectedData);
  const reset = useProductEpdDataStore((state) => state.reset);

  // Send errors to Noodl when they occur
  useEffect(() => {
    const outputs = (window as any).__productEpdDataModalOutputs;
    if (error) {
      outputs?.onError?.(error);
    }
  }, [error]);

  const handleClose = () => {
    const outputs = (window as any).__productEpdDataModalOutputs;
    setModalOpen(false);
    reset(); // Reset all state when closing modal
    if (outputs?.onClose) {
      outputs.onClose();
    }
  };

  const handleUpdate = (selectedData: any[], defaultSource: string) => {
    const outputs = (window as any).__productEpdDataModalOutputs;
    updateSelectedData(selectedData, defaultSource);
    if (outputs?.onUpdate) {
      outputs.onUpdate(selectedData, defaultSource);
    }
  };

  const handleSave = () => {
    const outputs = (window as any).__productEpdDataModalOutputs;
    if (outputs?.onSave) {
      outputs.onSave();
    }
  };

  const handleRequestMissingEpd = (epdNameOrId: string) => {
    const outputs = (window as any).__productEpdDataModalOutputs;
    if (outputs?.onRequestMissingEpd) {
      outputs.onRequestMissingEpd(epdNameOrId);
    }
  };

  return (
    <OverlayProvider>
      {isModalOpen && (
        <ProductEpdDataModal
          selectedEpdDataIds={selectedEpdDataIds}
          epdDataOptions={epdDataOptions}
          epdRawData={epdRawData}
          sourceType={sourceType}
          onClose={handleClose}
          onSave={handleSave}
          onUpdate={handleUpdate}
          onRequestMissingEpd={handleRequestMissingEpd}
          translations={translations as ProductEpdDataModalTranslations}
          requestMissingEpdTranslations={requestMissingEpdTranslations as RequestMissingEpdModalTranslations}
        />
      )}
    </OverlayProvider>
  );
}
